<template>
  <ContentWrapperControl>
    <div
      class="bg-white overflow-hidden mt-4 rounded-lg shadow mb-4 leading-normal"
    >
      <div class="p-6">
        <div class="mb-4">
          <TextControl
            @typing="typing"
            v-bind:value="last_name"
            v-bind:placeholder="lang('lbl_0000145')"
            type="text"
            name="last_name"
            :maxlength="20"
            uppercase
            required
          />
        </div>
        <div class="mb-4">
          <TextControl
            @typing="typing"
            v-bind:value="first_name"
            v-bind:placeholder="lang('lbl_0000146')"
            type="text"
            name="first_name"
            :maxlength="20"
            uppercase
            required
          />
        </div>
        <div class="mb-4">
          <div class="flex">
            <div class="flex-1 mr-3">
              <TextControl
                @typing="typing"
                v-bind:value="account_no"
                v-bind:disabled="serial_no.length > 0"
                :required="serial_no.length == 0"
                v-bind:placeholder="lang('lbl_0000093')"
                :maxlength="6"
                type="account_number"
                name="account_no"
                :error="account_no.length > 0 && account_no.length < 6"
                uppercase
              />
              <span
                v-if="account_no.length > 0 && account_no.length < 6"
                class="text-xs text-error"
                >{{ lang("lbl_0000247") }}</span
              >
            </div>
            <div class="flex-1">
              <TextControl
                @typing="typing"
                v-bind:value="serial_no"
                v-bind:disabled="account_no.length > 0"
                :required="account_no.length == 0"
                v-bind:placeholder="lang('lbl_0000094')"
                :maxlength="isOfficer ? 7 : 6"
                :error="serial_no.length > 0 && serial_no.length < 6"
                type="serial_number"
                name="serial_no"
                uppercase
              />
              <span
                v-if="serial_no.length > 0 && serial_no.length < 6"
                class="text-xs text-error"
                >{{ lang("lbl_0000248") }}</span
              >
            </div>
          </div>
          <div
            v-if="account_no.length == 0 && serial_no.length == 0"
            v-text="lang('lbl_0000238')"
            class="mt-1 text-xs text-grey-dark italic"
          ></div>
        </div>
        <div class="mb-4">
          <TextControl
            @typing="typing"
            @validating="validatingInput"
            @is-valid="is_valid.mobile = $event"
            v-bind:value="mobile_no"
            v-bind:placeholder="lang('lbl_0000007')"
            type="mobile"
            name="mobile_no"
            :maxlength="10"
            :registration="true"
            required
          />
        </div>
        <div class="mb-4">
          <TextControl
            @typing="typing"
            @validating="validatingInput"
            @is-valid="is_valid.email = $event"
            v-bind:value="email"
            v-bind:placeholder="lang('lbl_0000005')"
            type="email"
            name="email"
            :maxlength="50"
            :registration="true"
            required
          />
        </div>
        <div class="mb-4">
          <div>
            <TextControl
              @typing="typing"
              @validating="validatingInput"
              @is-valid="is_valid.username = $event"
              v-bind:value="username"
              v-bind:placeholder="lang('lbl_0000041')"
              type="username"
              name="username"
              :error="username.length < 6"
              :maxlength="24"
              :registration="true"
              required
            />
          </div>
          <div
            v-text="lang('lbl_0000053')"
            class="mt-1 text-xs text-grey-dark italic"
          ></div>
        </div>
        <div class="mb-4">
          <div>
            <TextControl
              @typing="typing"
              v-bind:value="password"
              v-bind:placeholder="lang('lbl_0000042')"
              type="password"
              name="password"
              :error="password.length < 8"
              :maxlength="24"
              strength
              required
            />
          </div>
          <div
            v-text="lang('lbl_0000060')"
            class="mt-1 text-xs text-grey-dark italic"
          ></div>
        </div>
        <div class="mb-4">
          <TextControl
            @typing="typing"
            @strong="strong"
            v-bind:value="con_password"
            v-bind:placeholder="lang('lbl_0000048')"
            type="password"
            name="con_password"
            required
            :error="con_password.length < 8 || password != con_password"
            :maxlength="24"
          />
          <span
            v-if="
              password.length > 0 &&
              con_password.length > 0 &&
              password != con_password
            "
            class="text-xs text-error"
            >{{ lang("lbl_0000237") }}</span
          >
        </div>
        <div
          class="mb-4 text-sm leading-normal text-grey-darkest flex flex-row items-start"
        >
          <CheckboxControl @toggle="toggle" v-bind:checked="agree">
          </CheckboxControl>
          <div>
            {{ lang("lbl_0000147") }}
            <router-link
              to="/end-user-license-agreement"
              class="no-underline text-primary font-bold"
            >
              {{ lang("lbl_0000133") }}
            </router-link>
            {{ lang("and") }}
            <router-link
              to="/privacy-policy"
              class="no-underline text-primary font-bold"
            >
              {{ lang("lbl_0000135") }} </router-link
            >.
          </div>
        </div>
        <div>
          <ButtonControl @click="show_confirm = true" :disabled="isDisabled">
            {{ lang("lbl_0000113") }}
          </ButtonControl>
        </div>
      </div>
    </div>
    <ModalControl
      :title="lang('lbl_0000244')"
      @closed="show_confirm = false"
      :dismiss="true"
      :show="show_confirm"
    >
      <div class="flex flex-col">
        <span class="mt-2 p-1">{{ lang("lbl_0000245") }}</span>
        <div class="bg-grey-lighter p-6 mt-2 rounded-lg">
          <div>
            <span class="text-grey-darker font-semibold mr-1">First Name:</span>
            <span class="uppercase">{{ first_name }}</span>
          </div>
          <div class="mt-4">
            <span class="text-grey-darker font-semibold mr-1">Last Name:</span>
            <span class="uppercase">{{ last_name }}</span>
          </div>
          <div class="mt-4" v-if="account_no">
            <span class="text-grey-darker font-semibold mr-1"
              >Account No.:</span
            >
            <span class="uppercase">{{ account_no }}</span>
          </div>
          <div class="mt-4" v-if="serial_no">
            <span class="text-grey-darker font-semibold mr-1">Serial No.:</span>
            <span class="uppercase">{{ serial_no }}</span>
          </div>
          <div class="mt-4">
            <span class="text-grey-darker font-semibold mr-1">Mobile No.:</span>
            <span>+63{{ mobile_no }}</span>
          </div>
          <div class="mt-4">
            <span class="text-grey-darker font-semibold mr-1"
              >Email Address:</span
            >
            {{ email }}
          </div>
          <div class="mt-4">
            <span class="text-grey-darker font-semibold mr-1">Username:</span>
            {{ username }}
          </div>
        </div>
      </div>
      <div class="flex flex-row mt-6">
        <ButtonControl
          class="mr-2"
          @click="show_confirm = false"
          :outline="true"
        >
          {{ lang("lbl_0000246") }}
        </ButtonControl>
        <ButtonControl class="ml-2" @click="join">
          {{ lang("lbl_0000015") }}
        </ButtonControl>
      </div>
    </ModalControl>
  </ContentWrapperControl>
</template>

<script>
import { onBeforeRouteLeave } from "vue-router";
import ButtonControl from "./../components/controls/ButtonControl.vue";
import ContentWrapperControl from "./../components/controls/ContentWrapperControl.vue";
import CheckboxControl from "./../components/controls/CheckboxControl.vue";
import TextControl from "./../components/controls/TextControl.vue";
import ModalControl from "@/components/controls/ModalControl.vue";
import User from "./../services/User.js";
import mixin from "./../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    CheckboxControl,
    TextControl,
    ModalControl,
  },
  data() {
    return {
      last_name: "",
      first_name: "",
      account_no: "",
      serial_no: "",
      username: "",
      email: "",
      mobile_no: "",
      password: "",
      con_password: "",
      agree: false,
      disabled: true,
      validating: false,
      passed: false,
      image: "",
      show_confirm: false,
      is_valid: {
        email: false,
        mobile: false,
        username: false,
      },
      special_characters: [
        "`",
        "~",
        "!",
        "@",
        "#",
        "$",
        "%",
        "^",
        "&",
        "*",
        "(",
        ")",
        "-",
        "+",
        "=",
        "{",
        "[",
        "}",
        "]",
        "|",
        "\\",
        ":",
        ";",
        '"',
        "'",
        "<",
        ",",
        ">",
        "?",
        "/",
      ],
    };
  },
  mounted() {
    this.$emit("checkauth", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000014"),
      show: true,
      back: true,
    });

    let state = this.$store.state.registration,
      that = this;

    this.last_name = state.last_name;
    this.first_name = state.first_name;
    this.account_no = state.account_no;
    this.serial_no = state.serial_no;
    this.username = state.username;
    this.email = state.email;
    this.mobile_no = state.mobile_no;
    this.password = state.password;
    this.con_password = state.con_password;
    this.agree = state.agree;
    this.image = this.getMediaPath("/cover/papsi_cover_family.jpg");

    onBeforeRouteLeave((to) => {
      let exclude = [
        "create-account-page",
        "create-account-verify-page",
        "create-account-verify-mobile-page",
        "create-account-verify-email-page",
        "create-account-enroll-pin-page",
        "create-account-confirm-pin-page",
        "create-account-done-page",
        "privacy-policy-page",
        "end-user-license-agreement-page",
      ];

      if (exclude.indexOf(to.name) === -1) {
        let store = that.$store.state.registration;

        store.last_name = "";
        store.first_name = "";
        store.account_no = "";
        store.serial_no = "";
        store.username = "";
        store.email = "";
        store.mobile_no = "";
        store.password = "";
        store.con_password = "";
        store.agree = false;
      }
    });
  },
  computed: {
    isOfficer() {
      return (
        this.serial_no &&
        (this.serial_no.startsWith("O-") || this.serial_no.startsWith("o-"))
      );
    },
    isDisabled() {
      // console.log({
      //   validating: this.validating,
      //   last_name: this.last_name.length == 0,
      //   first_name: this.first_name.length == 0,
      //   account_serial:
      //     this.account_no.length == 0 && this.serial_no.length == 0,
      //   username_empty: this.username.length == 0,
      //   mobile_empty: this.mobile_no.length == 0,
      //   password_empty: this.password.length == 0,
      //   confirm_empty: this.con_password.length == 0,
      //   agree: this.agree,
      //   email_valid: this.is_valid.email,
      //   mobile_valid: this.is_valid.mobile,
      //   username_valid: this.is_valid.username,
      //   passed: this.passed,
      // });

      return (
        this.validating ||
        this.last_name.length == 0 ||
        this.first_name.length == 0 ||
        (this.account_no.length == 0 && this.serial_no.length == 0) ||
        this.username.length == 0 ||
        this.mobile_no.length == 0 ||
        this.password.length == 0 ||
        this.con_password.length == 0 ||
        !this.agree ||
        this.special_characters.some((char) => this.username.includes(char)) ||
        !this.is_valid.email ||
        !this.is_valid.mobile ||
        !this.is_valid.username ||
        !this.passed
      );
    },
  },
  methods: {
    strong(passed) {
      this.passed = passed;
    },
    toggle(n) {
      this.agree = n;
      this.$store.state.registration.agree = n;
      this.disableButton();
    },
    typing(obj) {
      this[obj.name] = obj.value;
      this.$store.state.registration[obj.name] = obj.value;
      this.disableButton();
    },
    validatingInput(status) {
      this.validating = status;
    },
    disableButton() {
      this.disabled =
        this.validating ||
        this.last_name.length == 0 ||
        this.first_name.length == 0 ||
        (this.account_no.length == 0 && this.serial_no.length == 0) ||
        this.username.length == 0 ||
        this.mobile_no.length == 0 ||
        this.password.length == 0 ||
        this.con_password.length == 0 ||
        !this.agree ||
        this.special_characters.some((char) => this.username.includes(char)) ||
        !this.passed;
    },
    join() {
      this.$emit("showloader");
      this.show_confirm = false;

      User.validate({
        first_name: this.first_name,
        last_name: this.last_name,
        account_no: this.account_no.toUpperCase(),
        serial_no: this.serial_no.toUpperCase(),
        email: this.email,
        mobile_no: this.getMobile(),
        username: this.username,
        password: this.password,
        con_password: this.con_password,
        agreement: this.agree,
      })
        .then((response) => {
          let data = response.data.data,
            state = this.$store.state;

          state.registration.hash = data.hash;
          state.registration.pin = data.pin;
          state.registration.otp.mobile.pin = data.otp.mobile.pin;
          state.registration.otp.email.pin = data.otp.email.pin;

          this.$router.push("/signup/verify");
          this.$emit("hideloader");
        })
        .catch((error) => {
          this.$emit("hideloader");
          this.password = "";
          this.con_password = "";
          this.agree = false;
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
    getMobile() {
      return this.mobile_no.length != 0 ? "+63" + this.mobile_no : null;
    },
  },
};
</script>
